import { Group } from '../../../modules/admin/models';
import { ActionTypes, AUTHENTICATE, LOGOUT, SET_PROFILE } from './types';

export interface AuthActions {
  authenticate(accessToken: string, refreshToken: string): void;
  logout(): void;
  setProfile(
    id: number,
    username: string,
    email: string,
    name: string,
    groups: Group[],
    terms_ack: boolean,
    first_login: boolean,
    license: string
  ): void;
}

export const createActions = (dispatch: React.Dispatch<ActionTypes>): AuthActions => {
  return {
    authenticate: (accessToken: string, refreshToken: string): void => {
      dispatch({
        type: AUTHENTICATE,
        payload: {
          accessToken,
          refreshToken,
        },
      });
    },

    logout: (): void => {
      dispatch({ type: LOGOUT });
    },
    setProfile: (
      id: number,
      username: string,
      email: string,
      name: string,
      groups: Group[],
      terms_ack: boolean,
      first_login: boolean,
      license: string
    ): void => {
      dispatch({
        type: SET_PROFILE,
        payload: {
          id,
          username,
          email,
          name,
          groups,
          terms_ack,
          first_login,
          license,
        },
      });
    },
  };
};
